import moment from 'moment';

window.addEventListener('load', async () =>{
    // If medication expiry is greater than 6 hours from now, refresh list.
    let curURL = window.location.href;
    let whiteLabel = document.querySelector('.single-whitelabel_site');
    // don't set dataLayer if in quit smoking or on whitelabel template
    if(curURL.includes('quit-smoking') || whiteLabel){
        return;
    }
    let expireTime = (localStorage.getItem('dod_medications_expiry') ?? null);

    if(!moment(expireTime,'Y-MM-D h:mm:ss a').isAfter(moment([], 'Y-MM-D h:mm:ss a'), 'hour')){
        const event = new Event('update_medication_list');
        document.dispatchEvent(event);
    }
})


document.addEventListener('update_medication_list', () => {
    fetch(window.API_Path + 'medications')
        .then((response) => response.json())
        .then((data) => {
        let medications = data.response
        localStorage.setItem('dod_medications', JSON.stringify(medications));
        localStorage.setItem('dod_medications_expiry', moment().add(24, 'hours').format('Y-MM-D h:mm:ss a'));
    }).catch(err => console.log(err))
})
